import React from "react";
import PropTypes from "prop-types";
import DashedBorder from "@default/general-components/dashed-border";

import { useSolrContext } from "@e-fork/solr";
import useTranslate from "@default/hooks/use-translate";

const FiltersControlSorting = () => {
  const { currentSorting, setSorting, loading, config } = useSolrContext();
  const _t = useTranslate();

  const disabled = !!loading;

  const changeHandler = (option) => {
    setSorting(option.id, option.order);
  };

  const sortOptions = config.sorting;
  const currentIndex = sortOptions.findIndex(
    (option) => `${option.id}:${option.order}` === currentSorting
  );

  return (
    <div
      className="main-control group-switch filter-control-element sort-controls"
      data-sort-state={currentSorting}
      style={{
        "--animation-children": sortOptions.length,
        "--current-index": currentIndex >= 0 ? currentIndex : 0,
      }}
    >
      {sortOptions.map((option) => {
        const value = `${option.id}:${option.order}`;
        const isActive = value === currentSorting;
        return (
          <button
            key={value}
            className={isActive ? "active font-style-change" : "font-style-change"}
            onClick={() => changeHandler(option)}
            disabled={disabled}
          >
            <DashedBorder/>
            <span className="highlighted">{_t(`overview.sorting.${option.label}`)}</span>
            <span className="standard">{_t(`overview.sorting.${option.label}`)}</span>
          </button>
        );
      })}
    </div>
  );
};

FiltersControlSorting.propTypes = {};

export default FiltersControlSorting;
